import * as React from 'react';
import { type VariantProps } from 'class-variance-authority';
import { cn } from '../../utils';
import { buttonVariants } from './button';

export interface ButtonLinkProps
  extends
    React.AnchorHTMLAttributes<HTMLAnchorElement>,
    VariantProps<typeof buttonVariants> {}

const ButtonLink = React.forwardRef<HTMLAnchorElement, ButtonLinkProps>(
  ({ className, variant, size, hoverEffect, ...props }, ref) => {
    return (
      <a
        className={cn(
          buttonVariants({ variant, size, hoverEffect, className }),
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
ButtonLink.displayName = 'ButtonLink';

export { ButtonLink };
